<template>
    <ul class="sidebar">
        <!-- 多级菜单 -->
        <li
            v-for="(item, index) in menuList" :key="index"
            class="item"
        >
            <div
                v-if="item.list"
                class="fisrt-level"
                pointer
                @mouseenter="tabHover(index)"
                @mouseleave="() => isHover = false"
            >
                <!-- 多级菜单-第一级 -->
                <div class="category" @click="onCategoryClick(index)">
                    <div class="category-content-main">
                        <img
                            class="icon"
                            :class="{
                                'icon-agent': item.name === '律师智能体',
                            }"
                            :src="index !== current ? item.avatar : item.activeAvatar || item.avatar"
                        />
                        <div class="name">{{ item.name }}</div>
                    </div>
                    <img
                        class="icon-arrow"
                        src="https://lvlin-base.cdn.bcebos.com/fe-saas/component/sidebar/menu-arrow.png"
                        :class="{
                            'rotate-z-180deg': item.isFold,
                        }"
                    />
                </div>
                <!-- 多级菜单-第二级 -->
                <ul
                    class="sub"
                    :style="{
                        'max-height': item.isFold
                            ? 0
                            : `${46 * item.list.length}px`,
                    }"
                >
                    <router-link
                        v-for="(subitem, idx) in item.list"
                        :key="'subitem' + idx"
                        :to="{
                            name: subitem.routerName,
                            query: routers,
                        }"
                        tag="li"
                        pointer
                        :class="{
                            'notice-remind':
                                subitem.routerName === 'notice' &&
                                announcementStatus,
                        }"
                        data-stat-track
                    >
                        <div
                            class="law-tools"
                            :class="{'sub-hover': isHover && idx === subCurrent && index === hoverCurrent}"
                            @click="clickNav(subitem)"
                            @mouseenter="subHover(idx)"
                            @mouseleave="() => isHover = false"
                        >
                            <div class="name">{{ subitem.name }}</div>
                            <div
                                v-if="subitem.badgeText"
                                class="tool-icon"
                            >
                                {{ subitem.badgeText }}
                            </div>
                            <div
                                v-else-if="bkStatus && subitem.name === '我的百科'"
                                class="tool-icon"
                            >
                                {{ bkStatus }}
                            </div>
                            <div
                                v-if="unreadInfo[subitem.routerName]"
                                class="unread-num"
                            >
                                {{ numebrHanlder(unreadInfo[subitem.routerName], 99) }}
                            </div>
                        </div>
                    </router-link>
                </ul>
            </div>
            <!-- 单级菜单 -->
            <div
                v-else
                class="fisrt-level simple-level"
                :class="{'fisrt-level-hover': isHover && index === hoverCurrent}"
                @mouseenter="tabHover(index)"
                @mouseleave="() => isHover = false"
            >
                <router-link
                    :to="{
                        name: item.routerName,
                        query: routers,
                    }"
                    pointer
                    tag="div"
                    :class="{
                        'notice-remind':
                            item.routerName === 'notice' && announcementStatus,
                    }"
                    data-stat-track
                >
                    <div class="law-tools" @click="clickNav(item)">
                        <img
                            class="icon"
                            :src="index !== current ? item.avatar : item.activeAvatar || item.avatar"
                        />
                        <div
                            class="name"
                        >
                            {{ item.name }}
                        </div>
                        <div
                            v-if="item.badgeText"
                            class="tool-icon first-level"
                        >
                            {{ item.badgeText }}
                        </div>
                        <div
                            v-if="unreadInfo[item.routerName]"
                            class="unread-num"
                        >
                            {{ numebrHanlder(unreadInfo[item.routerName], 99) }}
                        </div>
                    </div>
                </router-link>
            </div>
        </li>
    </ul>
</template>
<script>
/**
 * @file Sidebar 边栏，树形菜单
 * @author YongZhang<zhangyong06@baidu.com>
 * @date 2019-10-08
 */
import {mapState, mapMutations, mapActions} from 'vuex';
import eventBus from '@/mixins/eventBus';
import {getTabNews} from '../utils/commonReq';
export default {
    mixins: [eventBus(['consult_unread_num', 'case_modify', 'bk_status_change'])],
    data() {
        return {
            theme2: 'light',
            routers: {},
            timer: null,
            newsTimer: null,
            // 课程上一次更新的时间戳
            courseUpdateTimer: '',
            current: -1,
            isHover: false,
            hoverCurrent: 0,
            subCurrent: 0,
            // 菜单--未读数信息 key 菜单路由
            unreadInfo: {
                // 1v1咨询
                consult: 0,
                // 案例管理
                caseManage: 0,
                // 华律1v1咨询
                platformConsult1v1: 0
            },
            bkStatus: ''
        };
    },
    components: {
    },
    computed: {
        ...mapState({
            menuList: state => state.Menu.menuList,
            announcementStatus: state => state.Menu.hasUnReadAnnouncement,
            userInfoNew: state => state.lawStore?.userInfoNew || {},
            latestId: state => state.Service.aiContract.latestId
        })
    },
    created() {
        this.getBkInfo();
    },
    watch: {
        userInfoNew(val) {
            // 律师角色
            if (+val?.user_role === 0) {
                this.getUnreadNum();
                this.repeatGetUnreadNum(0);

                // 智能合同轮询
                this.getLatestContract();
                this.getCurrentContract();

                this.getCommonUnreadNum();
                this.repeatGetTabNews();
            }

            // 代理商和律所
            if (+val?.user_role === 1 || +val?.user_role === 2) {
                this.getPlatformUnreadNum();
                this.repeatGetUnreadNum(1);
            }
        },
        '$route': {
            handler(val) {
                // 控制sidebar图标切换
                let path = val.path.slice(1);
                for (let i = 0; i < this.menuList.length; i++) {
                    if (this.menuList[i].routerName === path) {
                        this.current = i;
                        break;
                    }
                    if (this.menuList[i].list) {
                        for (let j = 0; j < this.menuList[i].list.length; j++) {
                            if (this.menuList[i].list[j].routerName === path) {
                                this.current = i;
                                return;
                            }
                        }
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapMutations({
            setBadgeTextValue: 'Menu/setBadgeTextValue'
        }),
        ...mapActions({
            getLatestContract: 'Service/getLatestContract',
            getCurrentContract: 'Service/getCurrentContract'
        }),
        getRequest(name) {
            const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
            const req = window.location.search.substr(1).match(reg);
            if (req !== null) {
                return decodeURIComponent(req[2]);
            }
            return null;
        },
        onCategoryClick(index) {
            this.$store.dispatch('Menu/togglePluginFoldStatus', index);
        },
        clickNav(data) {
            this.$wywLog.send({
                serverId: 16814,
                page: data.routerName || 'law',
                action: 'click',
                area: 'nav',
                uk: this.userInfoNew?.uk || '',
                fr: this.$route?.query?.fr || ''
            });
            if (data.name === '课程中心') {
                this.setBadgeTextValue({
                    routeName: '课程中心',
                    value: ''
                });
                localStorage.setItem(
                    'courseUpdateTimer',
                    this.courseUpdateTimer
                );
            }
        },
        // 请求1v1 咨询待跟进咨询数
        getUnreadNum() {
            return new Promise((resolve, reject) => {
                this.$http
                    .get('/bp/consult/getunfollowcnt')
                    .then(res => {
                        if (!res || +res.code !== 0 || !res.data) {
                            reject();
                            return;
                        }
                        resolve();
                        this.unreadInfo.consult = res?.data?.unfollow_cnt || 0;
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },
        // 请求华律端 1v1 待沟通咨询数
        getPlatformUnreadNum() {
            return new Promise((resolve, reject) => {
                this.$http
                    .get('/bp/platform/consult/list')
                    .then(res => {
                        if (!res || +res.code !== 0 || !res.data) {
                            reject();
                            return;
                        }
                        resolve();
                        this.unreadInfo.platformConsult1v1 = res?.data?.statistics_data.pending_com_cnt || 0;
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },
        // 案例修改后更新案例驳回数量
        on_case_modify() {
            this.getCommonUnreadNum();
        },
        /**
         * 轮训再上一个请求结果返回后 10min 后请求接口
         */
        repeatGetUnreadNum(userRole) {
            this.timer && clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                (userRole === 0 ? this.getUnreadNum() : this.getPlatformUnreadNum())
                    .then(() => {
                        // 接口请求成功继续下一次请求
                        this.repeatGetUnreadNum();
                    })
                    .catch(() => {
                        // 接口请求失败则不再继续轮训
                        this.timer = null;
                        clearTimeout(this.timer);
                    });
            }, 600000);
        },

        /**
         * 轮训再上一个请求结果返回后 10min 后请求接口
         */
        repeatGetTabNews() {
            this.newsTimer && clearTimeout(this.newsTimer);
            this.newsTimer = setTimeout(() => {
                getTabNews()
                    .then(data => {
                        this.courseUpdateTimer = data['课程中心'] || '';
                        // 接口请求成功继续下一次请求
                        this.repeatGetTabNews();
                    })
                    .catch(() => {
                        // 接口请求失败则不再继续轮训
                        this.newsTimer = null;
                        clearTimeout(this.newsTimer);
                    });
            }, 600000);
        },

        /**
         * 公共的请求未读数的方法
         */
        getCommonUnreadNum() {
            getTabNews().then(data => {
                const {info} = data || {};
                this.courseUpdateTimer = info['课程中心'] || '';
                // 上一次课程更新时间戳
                let courseUpdateTimer
                    = localStorage.getItem('courseUpdateTimer');
                if (
                    !courseUpdateTimer
                    || this.courseUpdateTimer > courseUpdateTimer
                ) {
                    this.setBadgeTextValue({
                        routeName: '课程中心',
                        value: ''
                    });
                }
                else if (this.courseUpdateTimer === courseUpdateTimer) {
                    this.setBadgeTextValue({
                        routeName: '课程中心',
                        value: ''
                    });
                }
            });
        },
        tabHover(index) {
            this.hoverCurrent = index;
            this.isHover = true;
        },
        subHover(index) {
            this.subCurrent = index;
            this.isHover = true;
        },

        /**
         * 数字处理
         */
        numebrHanlder(num, max) {
            if (!max) {
                return num || 0;
            }
            if (!num) {
                return 0;
            }
            return num > max ? `${max}+` : num;
        },
        getBkInfo() {
            this.$http
                .get('/bp/api/baike/info')
                .then(res => {
                    if (+res?.code === 0) {
                        // 0 未加入(未关联)， 1 待审核(审核中)， 2 百科词条&繁星已加入(已关联)， 3 百科词条加入&繁星计划未加入(已关联)
                        let bkMap = {
                            0: '未关联',
                            1: '审核中',
                            2: '已关联',
                            3: '已关联'
                        };
                        let status = res?.data?.status || 0;
                        this.bkStatus = bkMap[status] || '';
                    }
                })
                .catch(err => {});
        },
        on_bk_status_change() {
            this.getBkInfo();
        }
    }
};
</script>
<style lang="less" scoped>
.sidebar {
    padding-top: 10px !important;
    padding-right: 20px;
    padding-bottom: 20px;
    color: #1e1f24;
    border-right: 1px solid #eee;
    user-select: none;
    z-index: 1;
    overflow-y: scroll;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
    }

    /deep/ .router-link-active {
        .name {
            font-weight: 600;
        }
    }

    .item {
        margin-left: 20px !important;
    }

    .name {
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
    }

    .fisrt-level {
        margin-top: 10px;
    }

    .simple-level {
        height: 36px;

        .name {
            font-weight: 600 !important;
        }
    }

    .fisrt-level-hover {
        color: #05f;
    }

    .category {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .category-content-main {
            display: flex;
            align-items: center;

            .name {
                font-weight: 600;
            }
        }
    }

    .icon {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }

    .icon-arrow {
        width: 6px;
        height: 4px;
        transition: transform .2s ease-out;

        &.rotate-z-180deg {
            transform: rotateZ(180deg);
        }
    }

    .icon-agent {
        height: 18px;
        transform: translateY(-1px);
    }

    .sub {
        padding-left: 26px !important;
        color: #333;
        overflow: hidden;
        transition: max-height .2s ease-out;
        -webkit-transition: max-height .2s ease-out;
    }

    .notice-remind {
        position: relative;

        &::after {
            content: "";
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background-color: red;
            position: absolute;
            top: 50%;
            margin-top: -3.5px;
            right: 62px;
        }
    }

    .law-tools {
        margin-top: 10px;
        height: 36px;
        display: flex;
        align-items: center;
        font-weight: 400;

        &.sub-hover,
        &:hover {
            color: #05f;
            font-weight: 600;
        }

        .tool-icon {
            height: 18px;
            margin-left: 6px;
            color: #fff;
            font-size: 12px;
            font-weight: 500;
            text-align: center;
            padding: 0 5.5px;
            width: max-content;
            line-height: 18px;
            border-radius: 9px;
            background: #ff274b;
            box-shadow: 0 3px 10px 0 rgba(255, 39, 75, .3);
        }

        .unread-num {
            margin-left: 6px;
            height: 18px;
            padding: 0 7px;
            line-height: 18px;
            color: #fff;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            border-radius: 12px;
            background: #ff274b;
            box-shadow: 0 3px 10px 0 rgba(255, 39, 75, .3);
        }
    }
}
</style>
